<div class="search-container">
  <div class="search-icon"></div>
  <input
    class="search-input"
    type="text"
    [(ngModel)]="searchTerm"
    (ngModelChange)="onSearchTermChange($event)"
    [placeholder]="'login_page.search_offer' | translate"
  />
  <button class="search-button" type="button" (click)="emitFiltered(searchTerm)">
    <i class="fa fa-search"></i>
  </button>
</div>
